import type { Element, SlateEditor } from '@udecode/plate';

import { BaseFigureCaptionPlugin } from '../FigureCaptionBasePlugin';

export const deleteFigureCaption = (editor: SlateEditor, at: Element) => {
    // Before
    const pathBefore = editor.api.before(at);

    const entryBefore = editor.api.block({
        at: pathBefore,
    });

    if (entryBefore && entryBefore[0].type === editor.getType(BaseFigureCaptionPlugin)) {
        editor.tf.removeNodes({
            at: pathBefore,
            match: { type: editor.getType(BaseFigureCaptionPlugin) },
        });
    }

    // After
    const pathAfter = editor.api.after(at);

    const entryAfter = editor.api.block({
        at: pathAfter,
    });

    if (entryAfter && entryAfter[0].type === editor.getType(BaseFigureCaptionPlugin)) {
        editor.tf.removeNodes({
            at: pathAfter,
            match: { type: editor.getType(BaseFigureCaptionPlugin) },
        });
    }
};
